module.exports = __webpack_public_path__ + "img/register.486bdaa5.png";